var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPaperPlane = function SvgPaperPlane(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "paper-plane-a",
    d: "M8.7878386,60.2337835 C8.5388849,60.3404779 8.27085355,60.3954934 8,60.3954934 C6.8954305,60.3954934 6,59.5000629 6,58.3954934 L6,43.1273989 C6,42.1477087 6.70966458,41.312233 7.67644995,41.1537436 L40.8571429,35.7142857 L7.67644995,30.2748279 C6.70966458,30.1163385 6,29.2808627 6,28.3011725 L6,13.033078 C6,12.7622245 6.0550155,12.4941931 6.16170994,12.2452394 C6.59682118,11.2299799 7.77257903,10.7596767 8.7878386,11.194788 L61.7106565,33.8759957 C62.1826863,34.0782941 62.5588095,34.4544174 62.761108,34.9264471 C63.1962192,35.9417067 62.7259161,37.1174645 61.7106565,37.5525758 L8.7878386,60.2337835 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "paper-plane-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paper-plane-a"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 72.22,
    height: 72.203,
    fill: "#000",
    fillRule: "nonzero",
    mask: "url(#paper-plane-b)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPaperPlane);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/paper-plane.e449504e9e13d502b73713d657f51912.svg";